import styled from 'styled-components'

import breakpoints from '../../theme/breakpoints'

export const Container = styled.div`
  padding: 10px;

  ${breakpoints.up('desktop')} {
    padding: 20px;
  }
`

export const Text = styled.p`
  ${({ theme }) => theme.textStyles.H3};
  color: ${({ theme }) => theme.colors.nightRider};
  text-align: center;
`
